/*
 * @Author: 丁希虎
 * @Date: 2020-12-13 19:23:46
 * @Last Modified by: 丁希虎
 * @Last Modified time: 2021-01-28 21:31:34
 */
import Event from "./event";
import bridge from "./bridge2";
import callMiniProgram from "./miniProgramHybrid";
import constants from "./constants.js";

// 已调通方法
let jsCallAppFnList = ["getUserInfo"];
let appSendWebFnList = ["themeChange"];

// ios只能打印字符串
let GacNioBridge = {
  callMiniProgram,
  platform() {
    return new Promise((resolve) => {
      if (window.GacBridge) {
        window.GacBridge.init((platform) => {
          console.log(`执行platform，环境是${platform}`);
          //分别有： ios、 android、 miniprogram、 WXH5
          resolve(platform);
        });
      } else {
        bridge.init((platform) => {
          console.log(`执行platform，环境是${platform}`);
          resolve(platform);
        });
      }
    });
  },
  // js 主动获取app信息
  callApp(method, data = {}) {
    console.log("callApp", method);
    return new Promise((resolve) => {
      if (window.GacBridge) {
        //window.GacBridge.init((platform) => {
        console.log(`执行callApp，新版本 方法是${method}`);
        window.GacBridge.jsCallApp({ method, data }, function(res) {
          resolve(res);
        });
        //});
      } else {
        setTimeout(() => {
          console.log(`执行callApp，旧版本 方法是${method}`);
          bridge.jsCallApp({ method, data }, function(res) {
            resolve(res);
          });
        }, 500);
      }
    });
  },
  // js监听app通过 method 方法传递过来的数据
  listenApp(method, cb) {
    if (window.GacBridge) {
      window.GacBridge.init((platform) => {
        console.log(`准备执行registerHandler方法是 ${method}`);
        cb(); //先让外部监听 method 事件等APP改变则在下面触发
        window.GacBridge.registerHandler(method, (res) => {
          console.log(
            `执行registerHandler成功  - 新版本 ${JSON.stringify(res)}`
          );
          Event.$emit(method, res);
        });
      });
    } else {
      setTimeout(() => {
        //旧方法无法确保是否加载sdk
        if (typeof bridge.registerHandler === "function") {
          cb();
          bridge.registerHandler(method, (res) => {
            console.log(`执行registerHandler成功  - 旧版本`);
            Event.$emit(method, res);
          });
        }
      }, 500);
    }
  },

  // h5向小程序传递数据
  postMessage2Mini(type, data) {
    wx &&
      wx.miniProgram &&
      wx.miniProgram.postMessage({
        data: { type, data },
      });
  },

  // 事件常量
  constants,
};
export default GacNioBridge;
